import { render, staticRenderFns } from "./RevenueSchedule.vue?vue&type=template&id=28325d6b&"
import script from "./RevenueSchedule.vue?vue&type=script&lang=js&"
export * from "./RevenueSchedule.vue?vue&type=script&lang=js&"
import style0 from "./RevenueSchedule.vue?vue&type=style&index=0&id=28325d6b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports